import { Helmet } from 'react-helmet-async';
import InstagramSection from '../components/InstagramSection';
import GalleryLightbox from '../components/GalleryLightbox';

export default function InspirationPage() {
  const facebookHighlights = [
    {
      title: "CLASSIC BY NURAN ✨",
      text: "Vidste du, at vielsesringens bredde har betydning for stilen og udtrykket? Med Classic vielsesringene fra @nuransmykker kan I selv vælge, hvor brede jeres ringe skal være. Kom forbi butikken for meget mere vejledning 🤍",
      tags: ["#nuransmykker", "#vielsesringe", "#ringdesigner"],
      imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-137-639989608-2046706026108778-3908745731602171548-n.jpg"
    },
    {
      title: "PETIT RING OG ØRESTIKKER 🤍",
      text: "En fin og enkel serie fra @nuransmykker der både fås med brillanter og ædelsten i flere forskellige farver. Her ses ringen og ørestikkerne med brillantslebne diamanter 🤩",
      tags: ["#nuransmykker", "#petit", "#ring", "#earrings"],
      imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-113-641681091-2048567015922679-1442163617195137540-n.jpg"
    },
    {
      title: "ELÉ 🤍",
      text: "Den nye elegante Elé-serie fra @nuransmykker består af ring, ørestikker og halskæde, der alle er isat funklende brillantslebne diamanter ✨ Vælg mellem 14 karat rød-, hvid- eller rosaguld.",
      tags: ["#nuransmykker", "#jewelry", "#diamonds", "#gold", "#elé"],
      imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-770724535-2201547897291256-6216673389701746578-n.jpg"
    },
    {
      title: "GRACE RINGE FRA @NURANSMYKKER ✨",
      text: "Sommerens fineste accessory med ædelsten i de fineste farver! Vælg mellem London blue topas, røg topas, lyseblå topas, grøn ametyst, pink ametyst, granat eller morganit 😍",
      tags: ["#nuransmykker", "#grace", "#gemstones", "#colors", "#diamonds"],
      imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-767222368-2201547903957922-6641466863669271029-n.jpg"
    },
    {
      title: "HÅNDVÆRK FRA VÆRKSTEDET ⚒️",
      text: "Lodning, tilpasning og omsmeltning af gammelt guld. Vores guldsmede skaber unika smykker med sjæl og præcision midt i Brønshøj.",
      tags: ["#guldsmed", "#værksted", "#unika", "#håndværk"],
      imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762916558-2190988508347195-957866742761152989-n.jpg"
    },
    {
      title: "LOKAL URMAGERSERVICE ⌚",
      text: "Er dit ur stoppet eller har det brug for en kærlig hånd? Vi tilbyder batteriskift, trykprøvning og renovering af alle typer ure.",
      tags: ["#urmager", "#urereparation", "#brønshøj", "#ure"],
      imageUrl: "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762553405-2193861241393255-5759380788054099571-n.jpg"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Inspiration - Brønshøj Ure & Guld</title>
        <meta property="og:title" content="Inspiration - Brønshøj Ure & Guld" />
        <meta
          property="og:image"
          content="https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-137-639989608-2046706026108778-3908745731602171548-n.jpg"
        />
      </Helmet>

      {/* Header */}
      <section className="bg-[#0B132B] text-white pt-36 sm:pt-40 lg:pt-56 pb-16 sm:pb-20 lg:pb-28 border-b border-white/10 text-center">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs uppercase tracking-[0.3em] text-[#B5A897] font-semibold block">
            NYHEDER, SMYKKESERIER & SOCIALE MEDIER
          </span>
          <h1 className="font-serif text-3xl sm:text-5xl uppercase tracking-[0.2em] font-normal text-white">
            INSPIRATION & GALLERI
          </h1>
          <p className="text-xs sm:text-sm text-stone-300 max-w-2xl mx-auto uppercase tracking-widest font-sans leading-relaxed">
            Gå på opdagelse i vores nyeste smykkeserier, vielsesringe, værksted og billeder direkte fra forretningen.
          </p>
        </div>
      </section>

      <section className="py-20 bg-[#FAF8F5]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
          
          {/* Highlights grid */}
          <div className="space-y-8">
            <div className="text-center max-w-xl mx-auto">
              <div className="w-[1px] h-8 bg-[#B5A897] mx-auto mb-3"></div>
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#B5A897] font-semibold block">
                UDVALGTE OPSLAG
              </span>
              <h2 className="font-serif text-2xl sm:text-3xl font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">
                SENESTE OPSLAG & SMYKKENYHEDER
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {facebookHighlights.map((item, idx) => (
                <div key={idx} className="bg-[#F2EFE9] border border-[#E2DDD3] flex flex-col justify-between rounded-none shadow-none group">
                  <div className="aspect-square border-b border-[#E2DDD3] overflow-hidden bg-[#E2DDD3]">
                    <img
                      src={item.imageUrl.replace('https://assets.auxodev.dk/', 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/')}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-6 flex flex-col justify-between flex-1 space-y-4">
                    <div className="space-y-2">
                      <h3 className="font-serif text-base font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">{item.title}</h3>
                      <p className="text-xs text-stone-600 leading-relaxed font-sans">{item.text}</p>
                    </div>
                    <div className="flex flex-wrap gap-1.5 pt-2">
                      {item.tags.map((tag) => (
                        <span key={tag} className="text-[10px] uppercase tracking-wider font-semibold text-[#B5A897] bg-[#F9F8F6] px-2 py-0.5 border border-[#E2DDD3]">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Galleries */}
          <div className="space-y-16 pt-8 border-t border-[#E2DDD3]">
            <GalleryLightbox gallerySlug="egne-smykker" title="EGNE SMYKKEDESIGNS & HÅNDVÆRK" />
            <GalleryLightbox gallerySlug="specialdesign" title="SPECIALDESIGN & UNIKA KREATIONER" />
            <GalleryLightbox gallerySlug="guldsmedevaerksted" title="GLIMT FRA GULDSMEDEVÆRKSTEDET" />
            <GalleryLightbox gallerySlug="butikken" title="STEMNINGSBILLEDER FRA BUTIKKEN" />
          </div>

          {/* Social Feed Component */}
          <InstagramSection />

        </div>
      </section>
    </>
  );
}
